(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vinofy-shop-navigation"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vinofy-shop-more').forEach(function(panel){
  var media=window.matchMedia('(min-width:750px)');
  function adapt(){if(media.matches)panel.open=true;else if(!window.location.pathname.includes('/vf-'))panel.open=false;}
  adapt();media.addEventListener('change',adapt);
});

  } catch(e) { console.error(e); }
})();
})();
